import { render, staticRenderFns } from "./CmsGallery.vue?vue&type=template&id=22c47ec6&scoped=true"
import script from "./CmsGallery.vue?vue&type=script&lang=js"
export * from "./CmsGallery.vue?vue&type=script&lang=js"
import style0 from "./CmsGallery.vue?vue&type=style&index=0&id=22c47ec6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c47ec6",
  null
  
)

export default component.exports